// extracted by mini-css-extract-plugin
export default {"container":"index_container__brQQ8","avatarContainer":"index_avatarContainer__xRAPm","avatarSvg":"index_avatarSvg__4d1ET","loadingText":"index_loadingText__rvxZe"};